import React from 'react';
import { Button } from 'clad';

class DangerButton extends React.PureComponent {
    render() {
        const { props } = this;
        return <Button {...props} type="danger" />;
    }
}

export default DangerButton;
